import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import RealTimeMap from "./views/RealTimeMap";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/realtime",
      name: "realtime",
      component: RealTimeMap,
      props: (route) => ({ uid: route.query.uid })  
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
